import React from 'react'

function PercentageBanner({ bannerData, removeCover = false, center = false }) {
    return (
        <div className={`w-full px-3 md:max-w-[1280px] sm:m-auto flex flex-col gap-2 sm:flex-row md:gap-3 sm:flex-wrap sm:justify-start md:justify-evenly my-10`}>
            {bannerData.map(data => (
                <div
                    key={data.id}
                    className={`flex flex-col justify-between w-full sm:w-[386px] ${removeCover ? "bg-[#F1F1F1] text-[#012234] h-[249px]" : "bg-prompt-blue-204-bg h-[204px] text-[#E6EAED]"} 
                    ${center ? "items-center" : "items-start text-left"} object-cover bg-cover rounded-[8px] p-6 transition-all duration-300 ease-in-out`}
                >
                    <data.icon className="mb-4" />
                    <p className='text-f20 font-semibold mb-2'>{data.headerText}</p>
                    <p className={`text-f16 ${removeCover && "text-[#3C4848]"}`}>{data.text}</p>
                </div>
            ))}
        </div>
    );
}

export default PercentageBanner